/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Modules which admit settings
 */
export enum EnumFrontendLayoutSettingModuleName {
    /**
     * Frontend layout customization settings.
     */
    Customizations = 1,
}
